import { render } from "./MovimientosBanco.vue?vue&type=template&id=4b1b3bf7&scoped=true"
import script from "./MovimientosBanco.vue?vue&type=script&lang=js"
export * from "./MovimientosBanco.vue?vue&type=script&lang=js"

import "./MovimientosBanco.vue?vue&type=style&index=0&id=4b1b3bf7&scoped=true&lang=scss"

import exportComponent from "C:\\laragon\\www\\fronted_sit_bolivia\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4b1b3bf7"]])

export default __exports__